<div
  class="main-section relative font-nunito text-sm font-normal antialiased"
  [ngClass]="[store.sidebar ? 'toggle-sidebar' : '', store.menu, store.layout, store.rtlClass]"
>
  <!-- screen loader -->
  @if (isLoading) {
  <div class="screen_loader animate__animated fixed inset-0 z-[60] grid place-content-center bg-[#fafafa] dark:bg-[#060818]">
    <svg width="64" height="64" viewBox="0 0 135 135" xmlns="http://www.w3.org/2000/svg" fill="#4361ee">
      <path
        d="M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
      >
        <animateTransform attributeName="transform" type="rotate" from="0 67 67" to="-360 67 67" dur="2.5s" repeatCount="indefinite" />
      </path>
      <path
        d="M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
      >
        <animateTransform attributeName="transform" type="rotate" from="0 67 67" to="360 67 67" dur="8s" repeatCount="indefinite" />
      </path>
    </svg>
  </div>
  }

  <div class="text-black dark:text-white-dark">
    @if (showTopButton) {
    <div class="fixed bottom-6 z-50 ltr:right-6 rtl:left-6">
      <button
        type="button"
        class="btn btn-outline-primary animate-pulse rounded-full bg-[#fafafa] p-2 dark:bg-[#060818] dark:hover:bg-primary"
        (click)="goToTop()"
      >
        <svg width="24" height="24" class="h-4 w-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.5"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 20.75C12.4142 20.75 12.75 20.4142 12.75 20L12.75 10.75L11.25 10.75L11.25 20C11.25 20.4142 11.5858 20.75 12 20.75Z"
            fill="currentColor"
          />
          <path
            d="M6.00002 10.75C5.69667 10.75 5.4232 10.5673 5.30711 10.287C5.19103 10.0068 5.25519 9.68417 5.46969 9.46967L11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5304 3.46967L18.5304 9.46967C18.7449 9.68417 18.809 10.0068 18.6929 10.287C18.5768 10.5673 18.3034 10.75 18 10.75L6.00002 10.75Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
    }

    <div>
      <div class="absolute inset-0">
        @if (authentication_background_1) {
        <img [src]="apiUrl + '/' + authentication_background_1" alt="image" class="h-full w-full object-cover" />
        } @else {
        <img src="assets/images/auth/bg-gradient.png" alt="image" class="h-full w-full object-cover" />
        }
      </div>

      <!--<div
          class="relative flex min-h-screen items-center justify-center bg-[url(/assets/images/auth/map.png)] bg-cover bg-center bg-no-repeat px-4 py-4 dark:bg-[#060818]"
          >-->
      <div
        class="relative flex min-h-screen items-center justify-center bg-cover bg-center bg-no-repeat px-4 py-4 dark:bg-[#060818]"
        [ngStyle]="!hideMedia ? {
    'background-image': 'url(' + ((authentication_background_2) ? apiUrl + '/' + authentication_background_2 : '/assets/images/auth/map.png') + ')'
      } : {}"
      >
        <!--  <img src="assets/images/auth/coming-soon-object1.png" alt="image" class="absolute left-0 top-1/2 h-full max-h-[893px] -translate-y-1/2" />
            <img src="assets/images/auth/coming-soon-object2.png" alt="image" class="absolute left-24 top-0 h-40 md:left-[30%]" />
            <img src="assets/images/auth/coming-soon-object3.png" alt="image" class="absolute right-0 top-0 h-[300px]" />
            <img src="assets/images/auth/polygon-object.svg" alt="image" class="absolute bottom-0 end-[28%]" />-->
        <div
          class="relative flex w-full max-w-[1502px] flex-col justify-between overflow-hidden rounded-md backdrop-blur-lg lg:min-h-[658px] lg:flex-row lg:gap-10 xl:gap-0"
          [ngClass]="{ 'bg-white/60 dark:bg-black/50': !hideMedia, 'bg-white dark:bg-black': hideMedia }"
        >
          <!-- linear-gradient(225deg, rgb(29 254 199) 0%, rgb(110 126 214) 100%) -->
          @if (!hideMedia) {
          <div
            class="relative hidden w-full items-center justify-center bg-[linear-gradient(225deg,rgba(244,210,222)_0%,rgba(200,209,252)_100%)] p-5 lg:inline-flex lg:max-w-[835px] ltr:xl:skew-x-[0deg] rtl:xl:skew-x-[-0deg]"
          >
            <!--<div
                class="relative hidden w-full items-center justify-center bg-[linear-gradient(225deg,rgba(239,18,98,1)_0%,rgba(67,97,238,1)_100%)] p-5 lg:inline-flex lg:max-w-[835px] ltr:xl:skew-x-[0deg] rtl:xl:skew-x-[-0deg]"
                >-->
            <!--<div
                class="absolute inset-y-0 w-8 from-primary/10 via-transparent to-transparent xl:w-16 ltr:-right-10 ltr:bg-gradient-to-r ltr:xl:-right-20 rtl:-left-10 rtl:bg-gradient-to-l rtl:xl:-left-20"
              ></div>-->

            <!-- Title and Description above Carousel -->

            <div class="ltr:xl:-skew-x-[0deg] rtl:xl:skew-x-[0deg]">
              @if (mediaItems?.length) {
              <div class="relative mx-auto w-full max-w-[835px]">
                <!-- Title and Description Above Carousel -->
                <div class="mb-6 text-center">
                  <!--<h1 class="mb-2 text-3xl font-bold">Create, Translate, and Personalize <span class="text-primary">Videos in Minutes</span></h1>-->
                  <h1 class="mb-2 text-3xl font-bold">{{mediaItems[activeIndex].name}}</h1>
                  <p class="text-lg opacity-80">{{mediaItems[activeIndex].description}}</p>
                </div>
                <!-- Carousel Images / Videos -->
                <div class="carousel-container">
                  <div class="relative">
                    <!-- Display Media (Image or Video) -->
                    @if (!mediaItems[activeIndex].video_url) {
                    <div class="w-full">
                      <!-- Check if clickable_link exists, then wrap image in anchor tag -->
                      @if (mediaItems[activeIndex].clickable_link) {
                      <a [href]="mediaItems[activeIndex].clickable_link" target="_blank">
                        <img
                          [src]="mediaItems[activeIndex].image_url"
                          alt="Carousel Image"
                          class="h-[422px] w-full rounded-xl object-scale-down"
                          style="border-radius: 12px"
                        />
                      </a>
                      } @if (!mediaItems[activeIndex].clickable_link) {
                      <div>
                        <img
                          [src]="mediaItems[activeIndex].image_url"
                          alt="Carousel Image"
                          class="h-[422px] w-full rounded-xl object-scale-down"
                          style="border-radius: 12px"
                        />
                      </div>
                      }
                    </div>
                    } @if (mediaItems[activeIndex].video_url) {
                    <div class="w-full">
                      <!-- Check if clickable_link exists, then wrap video in anchor tag -->
                      @if (mediaItems[activeIndex].clickable_link) {
                      <a [href]="mediaItems[activeIndex].clickable_link" target="_blank">
                        <video
                          [src]="mediaItems[activeIndex].video_url"
                          preload="auto"
                          muted
                          autoplay
                          playsinline
                          controls
                          class="h-[422px] w-full rounded-xl object-scale-down"
                          style="height: 100%; border-radius: 12px"
                        ></video>
                      </a>
                      }
                      <!--  [poster]="apiUrl + '/' + this.authentication_banner"
                                loop
                                -->
                      @if (!mediaItems[activeIndex].clickable_link) {
                      <div>
                        <video
                          [src]="mediaItems[activeIndex].video_url"
                          preload="auto"
                          muted
                          autoplay
                          playsinline
                          controls
                          class="h-[422px] w-full rounded-xl object-scale-down"
                          style="height: 100%; border-radius: 12px"
                        ></video>
                      </div>
                      }
                    </div>
                    }
                    <!-- Carousel Navigation Arrows -->
                    <!--<button (click)="prevItem()" class="absolute left-0 top-1/2 -translate-y-1/2 transform text-4xl text-white">
                            <i class="fa fa-arrow-left"></i>
                          </button>
                          <button (click)="nextItem()" class="absolute right-0 top-1/2 -translate-y-1/2 transform text-4xl text-white">
                            <i class="fa fa-arrow-right"></i>
                          </button>-->
                  </div>
                </div>
                <!-- Carousel Indicators -->
                @if (mediaItems?.length > 1) {
                <div class="absolute bottom-4 left-1/2 flex -translate-x-1/2 transform gap-2" style="margin: -11px">
                  @for (item of mediaItems; track item; let i = $index) {
                  <span
                    [ngClass]="{
                      'bg-primary': i === activeIndex,
                      'bg-white dark:bg-black': i !== activeIndex
                    }"
                    class="h-2.5 w-2.5 cursor-pointer rounded-full"
                    (click)="activeIndex = i"
                  ></span>
                  }
                </div>
                }
              </div>
              } @if (mediaItems?.length == 0) {
              <div class="relative mx-auto w-full max-w-[835px]">
                <!-- Title and Description Above Carousel -->
                <!--<div class="mb-6 text-center">
                      <h1 class="mb-2 text-3xl font-bold">....</h1>
                      <p class="text-lg opacity-80">.................</p>
                    </div>-->
                <!-- Carousel Images / Videos -->
                <div class="carousel-container">
                  <div class="relative">
                    <!-- Display Media (Image or Video) -->
                    <div class="w-full">
                      <img
                        [src]="apiUrl + '/' + this.authentication_banner"
                        alt="Carousel Image"
                        class="h-[422px] w-full rounded-xl object-scale-down"
                        style="border-radius: 12px"
                      />
                    </div>
                  </div>
                </div>
                <!-- Carousel Indicators -->
                <div class="absolute bottom-4 left-1/2 flex -translate-x-1/2 transform gap-2" style="margin: -11px">
                  @for (item of mediaItems; track item; let i = $index) {
                  <span
                    [ngClass]="{
                      'bg-primary': i === activeIndex,
                      'bg-white dark:bg-black': i !== activeIndex
                    }"
                    class="h-2.5 w-2.5 cursor-pointer rounded-full"
                    (click)="activeIndex = i"
                  ></span>
                  }
                </div>
              </div>
              }

              <!--<div class="relative flex min-h-screen items-center justify-center">
                  <img
                    *ngIf="authentication_banner"
                    [src]="apiUrl + '/' + this.authentication_banner"
                    alt="Cover Image"
                    class="h-[522px] w-[522px] object-contain"
                    />
                    <img *ngIf="!authentication_banner" src="assets/images/auth/login.svg" alt="Cover Image" class="h-[522px] w-[522px] object-contain" />
                  </div>-->

              <!--<div class="relative flex min-h-screen items-center justify-center">
                  <img *ngIf="authentication_banner" [src]="apiUrl + '/' + this.authentication_banner" alt="Cover Image" class="h-full w-full object-cover" />
                  <img *ngIf="!authentication_banner" src="assets/images/auth/login.svg" alt="Cover Image" class="h-full w-full object-cover" />
                </div>-->
            </div>
          </div>
          }

          <div
            class="relative flex w-full flex-col items-center gap-6 px-4 pb-16 pt-6 sm:px-6"
            [ngClass]="{ 'justify-center lg:max-w-[667px]': !hideMedia, 'justify-start': hideMedia }"
          >
            <div class="flex w-full max-w-[440px] items-center gap-2 lg:absolute lg:start-20 lg:top-6 lg:max-w-full">
              <a routerLink="/" class="flex items-center gap-2">
                @if (logo) {
                <img [src]="apiUrl + '/' + this.logo" alt="Logo" class="max-h-14" />
                } @if (company) {
                <span class="text-2xl font-bold text-primary">{{ this.company }}</span>
                }
              </a>
            </div>
            <div class="flex w-full max-w-[440px] items-center gap-2 lg:absolute lg:end-6 lg:top-6 lg:max-w-full">
              <div class="ms-auto flex items-center gap-2 rounded-lg border border-white-dark/30 bg-white px-2 py-1.5 text-white-dark dark:bg-black">
                <img [src]="'assets/images/flags/' + selectedLanguageCode.toUpperCase() + '.svg'" alt="image" class="h-5 w-5 rounded-full object-cover" />
                <select
                  class="bg-transparent text-base font-bold uppercase outline-none"
                  [ngModel]="selectedLanguageCode"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="changeLanguageByCode($event)"
                >
                  @for (item of store.languageList; track item) {
                  <option [ngValue]="item.code">{{ getLanguageName(item) }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="w-full" [ngClass]="{ 'max-w-[440px]': !hideMedia }">
              <router-outlet></router-outlet>
            </div>
            <p class="absolute bottom-6 w-full text-center dark:text-white">© {{ currYear }}.{{ copyrightContent }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
